import React, { useState, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import { AuthHook } from '@hooks';
import { Input, Checkbox } from '@components/form';
import './Login.css';

const LoginPage = () => {
const {login} = AuthHook();
    const navigate = useNavigate();
    const [serverError, setServerError] = useState('');
    
    const methods = useForm({
        defaultValues: { id: '', password: '', saveId: false },
    });

    const { handleSubmit, reset, setValue, formState: { isSubmitting }, } = methods;

    useEffect(() => {
        const isIdSaved = localStorage.getItem('isIdSaved') === 'true';
        if (isIdSaved) {
            setValue('id', localStorage.getItem('savedUserId') || '');
            setValue('saveId', true);
        }
    }, [setValue]);


    const onSubmit = async ({ id, password, saveId }) => {
        setServerError('');
        try {
          await login({ username: id, password });
          if (saveId) {
            localStorage.setItem('savedUserId', id);
            localStorage.setItem('isIdSaved', 'true');
          } else {
            localStorage.removeItem('savedUserId');
            localStorage.setItem('isIdSaved', 'false');
          }
          navigate('/master/main');
          reset();
        } catch (err) {
            const msg = err.response?.data?.errorMessage || err.message || '로그인에 실패했습니다.';
            setServerError(msg);
        }
      };


return (
  <FormProvider {...methods}>
  <form onSubmit={handleSubmit(onSubmit) } autoComplete="off">
    <div className="login-main-container">
      <div className="login-container">
        {/* 로고 영역 */}
        <div className="logo2">
          <img src="/img/logo2.png" alt="회사 로고" />
        </div>

        {/* 로그인 폼 */}
        <div className="login-form">
          <h1>안전 교육센터 관리자 로그인</h1>
          {serverError && <p className="error-message red">{serverError}</p>}
          <div className="login_input_wrap">
            <Input
                name="id"
                type="text"
                placeholder="아이디를 입력해 주세요."
                required={true}
                maxLength="30"
            />
            <Input
                name="password"
                type="password"
                placeholder="비밀번호를 입력해 주세요."
                required={true}
                maxLength="20"
                autoComplete="new-password"
            />
          </div>
          <div className="remember-me">
            <Checkbox
                label="아이디 저장"
                name="saveId"
                required={false}
            />
          </div>
          <button type="submit" className="login-button"  disabled={isSubmitting} >{isSubmitting ? '로그인 중...' : '로그인'}</button>
        </div>
      </div>
    </div>
      <div style={{backgroundColor:"#f5f5f5", fontSize:"1.1rem", textAlign:"center"}}>
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Copyright &copy; 안전 센터 1566-3886</span>
            <span style={{marginLeft:"10px"}}><Link to="http://www.atos.co.kr/">주식회사 아토스</Link></span>
            <span style={{marginLeft:"10px"}}><Link to="https://edu.atos.co.kr/">산업안전교육센터</Link></span>
          </div>
        </div>
      </div>
  </form>
  
  </FormProvider>
 );




};

export {LoginPage};